import React,{ useEffect, useState } from "react";
import "./user.css";
import { useDispatch, useSelector } from 'react-redux';
import { fetchThemeData } from '../../admin/themeSlice';
import { Link, useLocation } from "react-router-dom";
import { assetUrl } from "../../functions/themeAssets";

function USER({children }) {
  const dispatch = useDispatch();
    const location = useLocation();

    const {companyLogoUrl,backButtonUrl} = useSelector(state => state.ui);
    const [logoUrl,setLogoUrl]=useState("");
    const [backUrl,setBackUrl]=useState("");

    const { user } = useSelector(state => state.auth);
    const { status: themeStatus, data: themeData } = useSelector(state => state.theme);
    const fromMobileAppInUrl =
      String(new URLSearchParams(location.search).get("fromMobileApp") || "").toLowerCase() ===
      "true";
    const fromMobileAppInUser = String(user?.fromMobileApp || "").toLowerCase() === "true";
    const persistedFromMobileApp = (() => {
      try {
        const persisted = JSON.parse(
          sessionStorage.getItem("userData") || "{}"
        );
        return String(persisted?.fromMobileApp || "").toLowerCase() === "true";
      } catch {
        return false;
      }
    })();
    const isFromMobileApp = fromMobileAppInUrl || fromMobileAppInUser || persistedFromMobileApp;
  const isLeaderboardRoute = /^\/leaderboard\/?$/.test(location.pathname);
  // Back inside the game: game -> rules -> welcome screen; elsewhere it leaves to the platform
  const internalBack =
    location.pathname === "/game" ? "/rules" : location.pathname === "/rules" ? "/login?save=true" : null;
  const leaderboardBackHref = String(process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "") || "/";

  const applyCustomTheme = (theme) => {
  if (!theme) return;

  document.documentElement.style.setProperty('--text-color', theme.text_color);
  document.documentElement.style.setProperty('--ui-color-1', theme.ui_color_1);
  document.documentElement.style.setProperty('--ui-color-2', theme.ui_color_2);
  document.documentElement.style.setProperty('--option-color', theme.option_color);
  document.documentElement.style.setProperty('--option-text-color', theme.option_text_color);
};
    
  useEffect(() => {
      if (!/^\/login(?:\/)?$/.test(location.pathname)) {
        if (themeStatus === "idle") {
          dispatch(fetchThemeData({ themeId: null }));
        }
      }
  }, [themeStatus, dispatch, location.pathname]);

  useEffect(()=>{
    setBackUrl(backButtonUrl);
    setLogoUrl(companyLogoUrl);
  },[backButtonUrl,companyLogoUrl])


  // browser tab name set by the admin
  useEffect(() => {
    if (themeData?.tab_name) document.title = String(themeData.tab_name);
  }, [themeData]);

  useEffect(() => {
    if (themeStatus !== "succeeded" || !themeData) return;

    applyCustomTheme(themeData.colors);

    const applyBodyBackground = () => {
      const body = document.body;
      const bg = window.innerWidth <= 768 ? themeData.background_mob : themeData.background_desk;
      const bgUrl = bg ? assetUrl(bg) : null;
      if (bgUrl) {
        body.style.backgroundImage = `url("${bgUrl}")`;
        body.style.backgroundSize = window.innerWidth <= 768 ? "100% 100%" : "cover";
        body.style.backgroundRepeat = "no-repeat";
        body.style.backgroundAttachment = "fixed";
      } else {
        body.style.removeProperty("background-image");
      }
    };

    applyBodyBackground();
    window.addEventListener("resize", applyBodyBackground);
    window.addEventListener("orientationchange", applyBodyBackground);
    return () => {
      window.removeEventListener("resize", applyBodyBackground);
      window.removeEventListener("orientationchange", applyBodyBackground);
      // the admin screens live outside this wrapper and must not inherit the game background
      document.body.style.removeProperty("background-image");
    };
  }, [themeStatus, themeData, location.pathname]);

  const handleLogoClick = (e) => {
    if (!isFromMobileApp) return;
    e.preventDefault();
    window.GameStatus?.postMessage?.("navigate_back");
  };

  const backButton = (
    <button type="button" className="back-default">
      Back
    </button>
  );

  return (
    <>
      <header className="upperaction">
        <a href={process.env.REACT_APP_BASE_URL} onClick={handleLogoClick}>
          <img src={logoUrl} className="logo-holder" alt="" />
        </a>
        {!isFromMobileApp && (
          <div className="back-holder">
            {internalBack ? (
              <Link to={internalBack}>{backButton}</Link>
            ) : (
              <a href={isLeaderboardRoute ? leaderboardBackHref : backUrl}>{backButton}</a>
            )}
          </div>
        )}
      </header>
      {children}
    </>
  );
}

export default USER;
